import Footer from '#app/components/footer.tsx'
import { HeroCarousel } from '#app/components/hero-carousel.tsx'
import AboutUsSection from '#app/components/proposito/about-us-section.tsx'
import CommitmentSection from '#app/components/proposito/commitment-section.tsx'
import { JoinEffortsSection } from '#app/components/proposito/join-efforts-section.tsx'
import ProgramsSection from '#app/components/proposito/programs-section.tsx'
import { type Route } from './+types/index.ts'
import { slidesProposito } from './config.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Propósito | 100prevalor' },
	{
		name: 'description',
		content:
			'Conocé nuestro propósito, programas y compromiso con la sostenibilidad.',
	},
]

export default function PropositoRoute() {
	return (
		<main className="font-parkinsans">
			<HeroCarousel
				slides={slidesProposito}
				showIndicators={false}
				showControls={false}
				actionButtonText={'Sumame al proyecto'}
			/>

			<AboutUsSection />
			<CommitmentSection />
			<ProgramsSection />
			<JoinEffortsSection />

			<Footer />
		</main>
	)
}
